export const GET_ORDER_CHATBOT_ANALYTICS = "GET_ORDER_CHATBOT_ANALYTICS"
export const SET_ORDER_CHATBOT_ANALYTICS = "SET_ORDER_CHATBOT_ANALYTICS"
export const SET_ORDER_CHATBOT_ANALYTICS_LOADER = "SET_ORDER_CHATBOT_ANALYTICS_LOADER"
export const SET_ORDER_CHATBOT_ANALYTICS_ERROR = "SET_ORDER_CHATBOT_ANALYTICS_ERROR"
export const RESET_ORDER_CHATBOT_ANALYTICS = "RESET_ORDER_CHATBOT_ANALYTICS"

// Conversations Actions
export const GET_CHATBOT_CONVERSATIONS = "GET_CHATBOT_CONVERSATIONS"
export const SET_CHATBOT_CONVERSATIONS = "SET_CHATBOT_CONVERSATIONS"
export const SET_CHATBOT_CONVERSATIONS_LOADER = "SET_CHATBOT_CONVERSATIONS_LOADER"
export const SET_CHATBOT_CONVERSATIONS_ERROR = "SET_CHATBOT_CONVERSATIONS_ERROR"
export const RESET_CHATBOT_CONVERSATIONS = "RESET_CHATBOT_CONVERSATIONS"